import swal from 'sweetalert2'
import moment from 'moment'
import store from './store/store'
import _ from 'lodash'

export const padZeroNumber = (v) => {
  return parseInt(v).toFixed(0) < 10 ? '0' + v.toFixed(0) : v.toFixed(0)
}

export const floatToHoursMins = (number) => {
  const hours = Math.floor(number)
  const minutes = (number % 1) * 60
  return {hours, minutes, float: number}
}

export const inputTimeTofloat = (time) => {
  const hours = time.slice(0, 2)
  const minutes = time.slice(3, 5)
  return hoursMinsToFloat(hours, minutes)
}

export const hoursMinsToFloat = (hours, minutes) => {
  return parseInt(hours) + (parseInt(minutes) / 60)
}

export const handleResponse = async (promise) => {
  let response
  try {
    response = await promise
    if (response.body.success || response.body.created) {
      swal({
        type: 'success',
        text: response.body.success || 'Ação executada com sucesso'
      })
    } else if (response.body.info) {
      swal({
        type: 'info',
        text: response.body.info
      })
    }
  } catch (error) {
    response = error
    if (error.body.error) {
      swal({
        type: 'error',
        text: error.body.error
      })
    }
  }
  return response
}

export function groupBy (data, key) {
  return _.chain(data)
    .groupBy(i => getWithDotNotation(i, key))
    .toPairs()
    .value()
}

export const getWithDotNotation = (model, column, character = '.') => {
  // access with string the attributes of objects with dot notation... e.g: {a: {b: true}} = parseColumn(obj, 'a.b')
  return column.split(character).reduce((o, i) => o[i], model)
}

export const formatDateToSend = (momentDate) => {
  return momentDate.format('YYYY-MM-DDTHH:mm:ss')
}

export const isInputTimeValid = (time, dots = false) => {
  let regex
  if (dots) {
    if (time.length !== 5) { return false }
    regex = /^([0-9]|0[0-9]|1?[0-9]|2[0-3]):[0-5]?[0-9]$/
  } else {
    if (time.length !== 4) { return false }
    regex = /^([0-9]|0[0-9]|1?[0-9]|2[0-3])[0-5]?[0-9]$/
  }
  return regex.test(time)
}

export const inputTimeToMoment = (time, dots = false) => {
  let slice = [[0, 2], [2, 4]]
  if (dots) {
    slice[1] = [3, 5]
  }
  return moment().utc().set({hour: time.slice(slice[0][0], slice[0][1]), minute: time.slice(slice[1][0], slice[1][1])})
}

export const resetStateToDefault = (state, defaultState) => {
  // it's a closure and will change outside state
  Object.assign(state, defaultState)
}

export const removeDuplicatesArray = (arrayOfObjects, key) => {
  let tester = []
  let result = []
  arrayOfObjects.forEach(el => {
    if (tester.indexOf(el[key]) === -1) {
      tester.push(el[key])
      result.push(el)
    }
  })
  return result
}

export const hasPermission = (conditions, userRoles) => {
  let isValid = false

  const verifyPermission = (spec, roles) => {
    return (typeof _.find(roles, _.pick(spec, 'module', 'action')) !== 'undefined')
  }

  if (!userRoles) {
    userRoles = store.getters.getUserInfo.roles
  }

  const userRolesNames = userRoles.map(r => r.name)

  if (conditions.module) {
    if (conditions.filter) {
      const filters = conditions.filter

      for (let i = 0; i < filters.length; i++) {
        conditions.filter = filters[i]

        isValid = isValid || verifyPermission(conditions, userRoles)
      }
    } else {
      isValid = verifyPermission(conditions, userRoles)
    }
  } else if (conditions.any) {
    for (let role of conditions.any) {
      isValid = userRolesNames.includes(role)
    }
  } else if (conditions.multiple) {
    let rolesUserHasThatIsRequired = []
    for (let role of conditions.any) {
      if (userRolesNames.includes(role)) {
        rolesUserHasThatIsRequired.push(role)
      }
    }
    isValid = rolesUserHasThatIsRequired.length === conditions.multiple.length
  }
  return isValid
}

export function preLoadImages (list) {
  // receive a list of urls, you should keep the return saved in some place
  let images = []
  for (let i = 0; i < list.length; i++) {
    let image = new Image()
    image.src = list[i]
    images.push(image)
  }
  return images
}

export const datetimeToTimeString = (datetime) => datetime.substr(11, 5)

export const floatToHoursMinsString = (number) => {
  const hours = Math.floor(number)
  const minutes = (number % 1) * 60
  return `${padZeroNumber(hours)}:${padZeroNumber(minutes)}`
}

export function mostCommon (array) {
  return _.head(_(array)
    .countBy()
    .entries()
    .maxBy('[1]'))
}



// WEBPACK FOOTER //
// ./src/utils.js